import React, {useState} from "react";
import LoginHeader from "./login-header/LoginHeader";
import Login from "./login/Login";
import Welcome from "./welcome/Welcome";

const LoginPageComponents =() =>{
  return (
    <div>
      <div class="grid-container-main">
        <Login></Login>
      </div>
  </div>
  );
}

export default LoginPageComponents;